<template>
  <div>
    <p class="show_chart">
      <span>
        Total Effective Insurance Amount:
        {{ $utils.formatAmount(totalInsuranceAmount) }}
      </span>
      <span>Currency: USD</span>
    </p>
    <table-view
      v-if="visible"
      ref="tableList"
      tableCardTitle="Insurance List"
      :right-btn-options="{
        text: 'Add',
        isHavePermission: $storage.getItem('btn')['Insurance-Add'],
      }"
      :tableModel="tableModel"
      @changeTitleActionBtn="handleTitleActionBtn"
      @pageChange="handlePageChange"
      :row-class-name="tableRowClassName"
      :tableData="tableData"
      :pages="pages"
    >
      <!-- files -->
      <template v-slot:files="{ tableRow }">
        <el-popover
          placement="top"
          trigger="click"
          v-if="tableRow.row.files && tableRow.row.files.length"
        >
          <div
            style="text-align: center"
            v-for="item in tableRow.row.files"
            :key="item.id"
          >
            <a href="javascript:void (0)" @click="handleDownload(item.id)">
              {{ item.name }}
            </a>
          </div>
          <el-button type="text" slot="reference">Check</el-button>
        </el-popover>
        <span v-else></span>
      </template>
      <!-- lastModified -->
      <template v-slot:lastModified="{ tableRow }">
        {{ tableRow.row.lastModified || tableRow.row.createTime }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          v-if="$storage.getItem('btn')['Insurance-View']"
          href="javascript:;"
          :id="tableRow.id"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63; font-size: 18px"
          @click="handleView(tableRow)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow)"
        >
          <a
            v-if="$storage.getItem('btn')['Insurance-Delete']"
            href="javascript:void (0);"
            class="icon-trash1"
            slot="reference"
            style="color: #3a3f63"
          />
        </el-popconfirm>
      </template>
      <template v-slot:amount="{ tableRow }">
        {{ tableRow.row.amount | formatAmount }}
      </template>
      <template v-slot:localAmount="{ tableRow }">
        {{ tableRow.row.localAmount | formatAmount }}
      </template>
    </table-view>
    <router-view></router-view>
  </div>
</template>

<script>
import { getInsTable, deleteIns, download } from './api'

export default {
  data() {
    const isNotEmpty = arr => Array.isArray(arr) && arr.length > 0
    const tableModel = [
      // {
      //   width: 150,
      //   label: 'ID',
      //   prop: 'id',
      // },
      // {
      //   width: 160,
      //   label: 'Insurance Category',
      //   prop: 'insuranceCategoryStr',
      // },
      {
        width: 130,
        label: 'Insurance Type',
        prop: 'insuranceTypeStr',
      },
      {
        width: 130,
        label: 'Effective Date',
        prop: 'effectiveDate',
      },
      {
        width: 130,
        label: 'Expiration Date',
        prop: 'expirationDate',
      },
      {
        width: 150,
        label: 'Insurance Provider',
        prop: 'insuranceProviderStr',
      },
      {
        width: 120,
        label: 'Local Currency',
        prop: 'localCurrency',
      },
      {
        width: 200,
        label: 'Local Amount',
        slotName: 'localAmount',
      },
      {
        width: 200,
        label: 'Amount $',
        slotName: 'amount',
      },
      {
        minWidth: 120,
        label: 'Modified By',
        prop: 'operator',
      },
      {
        width: 130,
        label: 'Attachments',
        slotName: 'files',
      },
      {
        width: 130,
        label: 'Last Modified',
        slotName: 'lastModified',
      },
      {
        width: 120,
        label: 'Action',
        slotName: 'action',
        fixed: 'left',
      },
    ]
    return {
      tableModel,
      tableData: [],
      totalInsuranceAmount: 0,
      isNotEmpty,
      pages: {},
      customerId: this.$route.params.customerId,
      visible: false, // index.vue tablelist显隐状态
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    async handleDownload(id) {
      try {
        await download(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    tableRowClassName({ row }) {
      if (row.status) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        this.totalInsuranceAmount = 0
        params = {
          companyId: this.customerId,
          ...params,
        }
        const res = await getInsTable(params)
        const { data, page } = res
        this.tableData = data
        if (data.length) {
          this.totalInsuranceAmount = data[0].insuranceTotalAmountStr
        }
        this.pages = page
      } catch (err) {
        console.log(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    // handleCancel() {
    //   this.formId = ''
    //   this.form.resetFields()
    // },
    // add按钮事件
    handleTitleActionBtn() {
      this.visible = false
      this.$router.push({
        path: `/customer-management/${this.customerId}/info/insuranceAdd-detail`,
      })
    },
    // Action -> Edit
    handleView(curRow) {
      const params = {
        id: curRow.row.id,
      }
      this.visible = false
      this.$router.push({
        path: `/customer-management/${this.customerId}/info/insurance-detail?id=${params.id}`,
      })
    },
    // Action -> Delete
    async handleRemoveItem(curRow) {
      try {
        const params = {
          id: curRow.row.id,
        }
        await deleteIns(params)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.log(err)
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const fullPath = newValue.fullPath
        fullPath.substring(fullPath.lastIndexOf('/'), fullPath.length) ===
        '/insurance'
          ? (this.visible = true)
          : (this.visible = false)
        this.customerId = newValue.params.customerId
      },
    },
  },
}
</script>

<style scoped lang="scss">
.show_chart {
  display: flex;
  position: relative;
  top: 75px;
  left: 25px;
  font-size: 14px;
  span {
    margin-right: 100px;
  }
}
</style>
